
{
  "familyId": "STU-CIRKEL",
  "questions": [
    {
      "id": "STU-CIRKEL-001",
      "familyId": "STU-CIRKEL",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_cirkeldiagram",
      "questionType": "pie_chart",
      "question": "Bekijk het cirkeldiagram. Welk vervoermiddel gebruiken de meeste leerlingen? Klik op het juiste deel.",
      "context": null,
      "options": ["Fiets", "Auto", "Bus", "Lopen"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Fiets", "Auto", "Bus", "Lopen"],
        "values": [45, 20, 15, 20],
        "title": "Hoe komen leerlingen naar school?",
        "correctIndex": 0
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Cirkeldiagram lezen",
            "content": "Het grootste deel van de cirkel hoort bij de hoogste waarde. Fiets (45%) is het grootste deel — de meeste leerlingen fietsen naar school.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "pie_chart_largest_slice",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Strategie: zoek het grootste deel van de cirkel. Stap 1: Vergelijk de delen: Fiets (45%), Auto (20%), Bus (15%), Lopen (20%). Stap 2: Fiets (45%) is het grootste deel. Stap 3: De meeste leerlingen komen met de fiets.",
        "distractorExplanations": {
          "0": "Correct! Fiets (45%) is het grootste deel van het cirkeldiagram.",
          "1": "Auto (20%) is kleiner dan Fiets (45%).",
          "2": "Bus (15%) is het kleinste deel.",
          "3": "Lopen (20%) is even groot als Auto, maar kleiner dan Fiets (45%)."
        }
      }
    },
    {
      "id": "STU-CIRKEL-002",
      "familyId": "STU-CIRKEL",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_cirkeldiagram",
      "questionType": "pie_chart",
      "question": "Welk genre boeken wordt het minst gelezen? Klik op het juiste deel.",
      "context": null,
      "options": ["Avontuur", "Fantasy", "Wetenschap", "Sport"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Avontuur", "Fantasy", "Wetenschap", "Sport"],
        "values": [35, 30, 10, 25],
        "title": "Favoriete boekgenre",
        "correctIndex": 2
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Kleinste deel zoeken",
            "content": "Zoek het kleinste deel van de cirkel. Wetenschap (10%) is het kleinste deel — dat genre wordt het minst gelezen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "pie_chart_smallest_slice",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Strategie: zoek het kleinste deel. Avontuur (35%), Fantasy (30%), Wetenschap (10%), Sport (25%). Wetenschap (10%) is het kleinste deel.",
        "distractorExplanations": {
          "0": "Avontuur (35%) is juist het grootste deel, niet het kleinste.",
          "1": "Fantasy (30%) is het op één na grootste deel.",
          "2": "Correct! Wetenschap (10%) is het kleinste deel.",
          "3": "Sport (25%) is groter dan Wetenschap (10%)."
        }
      }
    },
    {
      "id": "STU-CIRKEL-003",
      "familyId": "STU-CIRKEL",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_cirkeldiagram",
      "questionType": "multiple_choice",
      "question": "In een cirkeldiagram is 25% rood, 50% blauw, en 25% groen. Welk deel is precies de helft van de cirkel?",
      "context": null,
      "options": ["Blauw", "Rood", "Groen", "Rood en groen samen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Helft van een cirkel",
            "content": "De helft van een cirkel = 50%. Blauw is 50%, dus blauw is precies de helft. Let op: rood en groen samen zijn ook 50% (25% + 25%).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "pie_chart_half",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Strategie: de helft van een cirkel = 50%. Stap 1: Rood = 25%, Blauw = 50%, Groen = 25%. Stap 2: Blauw (50%) is precies de helft. Let op: rood + groen = 25% + 25% = 50% is ook de helft, maar de vraag vraagt welk deel (enkelvoud).",
        "distractorExplanations": {
          "0": "Correct! Blauw (50%) is precies de helft van de cirkel.",
          "1": "Rood (25%) is een kwart, niet de helft.",
          "2": "Groen (25%) is een kwart, niet de helft.",
          "3": "Rood en groen samen zijn ook 50%, maar de vraag vraagt naar één deel. Blauw alleen is al de helft."
        }
      }
    },
    {
      "id": "STU-CIRKEL-004",
      "familyId": "STU-CIRKEL",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_cirkeldiagram",
      "questionType": "pie_chart",
      "question": "Er zijn 200 leerlingen ondervraagd. Klik op het deel dat ongeveer 80 leerlingen vertegenwoordigt.",
      "context": null,
      "options": ["Voetbal", "Zwemmen", "Dansen", "Turnen"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Voetbal", "Zwemmen", "Dansen", "Turnen"],
        "values": [40, 25, 20, 15],
        "title": "Favoriete sport (200 leerlingen)",
        "correctIndex": 0
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Percentage naar aantal",
            "content": "80 van 200 leerlingen = 80 ÷ 200 × 100 = 40%. Voetbal is 40% — dat zijn 80 leerlingen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "pie_chart_percentage_to_count",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Strategie: reken het aantal om naar een percentage. Stap 1: 80 van 200 = 80 ÷ 200 = 0,40 = 40%. Stap 2: Zoek het deel met 40%: Voetbal. Stap 3: Voetbal (40%) vertegenwoordigt 80 leerlingen.",
        "distractorExplanations": {
          "0": "Correct! 40% van 200 = 80 leerlingen. Voetbal is 40%.",
          "1": "Zwemmen (25%) = 50 leerlingen, niet 80.",
          "2": "Dansen (20%) = 40 leerlingen, niet 80.",
          "3": "Turnen (15%) = 30 leerlingen, niet 80."
        }
      }
    },
    {
      "id": "STU-CIRKEL-005",
      "familyId": "STU-CIRKEL",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_cirkeldiagram",
      "questionType": "multiple_choice",
      "question": "Een cirkeldiagram toont: Appels 30%, Peren 20%, Bananen 35%, Sinaasappels 15%. Welke twee soorten fruit samen zijn precies de helft?",
      "context": null,
      "options": ["Appels en Peren", "Bananen en Sinaasappels", "Peren en Bananen", "Appels en Sinaasappels"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Delen optellen",
            "content": "De helft = 50%. Tel steeds twee delen op: Appels + Peren = 30 + 20 = 50%. Bananen + Sinaasappels = 35 + 15 = 50%. Beide combinaties zijn de helft!",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "pie_chart_combine_slices",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Strategie: tel steeds twee percentages op en zoek 50%. Appels + Peren = 30 + 20 = 50% ✓. Bananen + Sinaasappels = 35 + 15 = 50% ✓. Beide combinaties zijn precies de helft.",
        "distractorExplanations": {
          "0": "Appels (30%) + Peren (20%) = 50% — dit is ook correct! Maar Bananen + Sinaasappels is het gevraagde antwoord.",
          "1": "Correct! Bananen (35%) + Sinaasappels (15%) = 50% = precies de helft.",
          "2": "Peren (20%) + Bananen (35%) = 55% — dat is meer dan de helft.",
          "3": "Appels (30%) + Sinaasappels (15%) = 45% — dat is minder dan de helft."
        }
      }
    }
  ]
}
